// Copyright (c) 2019-24 Stax·ai, Inc.
// See LICENSE.md file in project root directory
import React from 'react';
import { toast } from 'react-toastify';
import TeamUsers from './TeamUsers';
import Checkbox from '../Checkbox';
import copyText from '../../utilities/copy';
import api from '../../api';
export default class TeamSettings extends React.Component {

    state = {
        mfaEnabled: false, 
        ssoEnabled: true,
        samlIssuer: "",
        samlCert: "", 
    }

    componentDidMount = async () => {
        const load = async () => {
            if(!this.props.team || !this.props.team.sync)
                return setTimeout(load, 500);
            
            const mfaEnabled = this.props.team.security?.twoFactorAuth === "email";
            const ssoEnabled = this.props.team.security?.sso?.enabled?? false; 

            const { samlIssuer, samlCert } = this.props.team.security?.sso?.azure?? {
                samlIssuer: "",
                samlCert: "-----BEGIN CERTIFICATE-----\n ....\n-----END CERTIFICATE-----\n"
            };

            this.setState({
                mfaEnabled, 
                ssoEnabled,
                tenantId: this.props.team.sync.tenantId?? "",
                samlIssuer,
                samlCert
            });

        }
        load(); 
    }


    saveSecurityChanges = async() => {
        this.props.loading(9999); 
        const security = {...this.props.team.security}; 
        security.sso.azure = {
            samlIssuer: this.state.samlIssuer,
            samlCert: this.state.samlCert
        }

        await this.props.updateTeam({security});
        // Did we change the ssoEnabled? 
        if(this.state.ssoEnabled !== this.props.team.security?.sso?.enabled){
            await api.post('/team/toggleSso', {enabled: this.state.ssoEnabled}); 
            security.sso.enabled = !security.sso.enabled;
        }
            
        // Did we enabled MFA?  TODO: This will need to be updated if we ever do anything other than email MFA
        if(this.state.mfaEnabled && security.twoFactorAuth !== 'email'){
            await api.post('/team/toggleMfa', {method: 'email'}); 
            security.twoFactorAuth = 'email';
        }
        else if(!this.state.mfaEnabled && security.twoFactorAuth === 'email'){
            await api.post('/team/toggleMfa', {method: ''});
            security.twoFactorAuth = '';
        }

        await this.props.updateTeam({security}, false)

        setTimeout(() => {
            this.setState({securityChanged: false});
            this.props.loaded(); 
        }, 700);
    } 

    handleMfaToggle = () => {

        this.props.modal("confirm-caution", {
            message: this.state.mfaEnabled?
            <>
                <p>You are about to disable Multi-Factor Authentication (MFA) for your team.</p>
                <p>This means that the additional security layer requiring a verification code will be removed. Proceed only if you are sure about this change.</p>
            </>
            :
            <>
                <p>Are you ready to enhance your team's security?</p>
                <p><strong>Enabling MFA </strong>will require all team members to use a two-factor authentication code sent to their registered email address with STAX.AI for additional account security.</p>
            </>,
            action: async() => {
                this.setState({mfaEnabled: !this.state.mfaEnabled, securityChanged: true});
            }
        });
    } 

    handleSsoToggle = () => {

        // this.props.modal('configure-sso', {})

        this.props.modal("confirm-caution", {
            message: this.state.ssoEnabled?
            <>
                <p>You are about to <strong>disable Single Sign-On (SSO) </strong>with Microsoft Azure for your team.</p>
                <p>Disabling SSO means your team members will no longer be able to log in using their Microsoft Azure credentials. They will need to reset their passwords for direct access. Ensure this is in line with your team's access policy before proceeding.</p>
                <p></p>
            </>
            :
            <>
                <p>Ready to simplify your team's login process?</p>
                <p>Enabling SSO with Microsoft Azure allows team members to log in using their Azure credentials, streamlining access and enhancing security. Make sure all team members have active Azure accounts.</p>
            </>,
            action: async() => {
                this.setState({ssoEnabled: !this.state.ssoEnabled, securityChanged: true});
            }
        });

        
    } 

    renderLockedInput = (value, onChange, isEditing) => {
        return (
            <div
                className='settings-password-container'
            >
                <input
                    id="tenantId"
                    name="tenantId"
                    type={isEditing? "text": "password"}
                    placeholder=""
                    className={isEditing? "input-inline-text": ""}
                    value={value}
                    onChange={onChange}
                    style={{
                        marginTop: 0,
                        width: this.state.editTenantId? 230: 360
                    }}
                />
                {!isEditing && 
                <div
                    className="settings-password-button"
                    style={{marginTop: 0, top: 0}}
                    onClick={() => {
                        this.setState({
                            editTenantId: true,
                        });
                        document.getElementById("tenantId").focus();
                    }}
                >
                    Update Tenant Id
                </div>}
                {this.state.editTenantId && 
                <input 
                    class='input-inline-submit'
                    type='submit'
                    value='Submit'
                    style={{marginTop: 0, top: 0}}
                    onClick={() => {this.setState({editTenantId: false})}}
                />}
            </div>
        )
    }

    render = () => {

        return (
            <>
            <TeamUsers
                {...this.props}
            />

            <div
                className='settings'
            >
               <h2>
                    Security Configurations 
                    {this.state.securityChanged &&
                    <span 
                        className='plan-editor-button' 
                        style={{marginLeft: 20}}
                        onClick={this.saveSecurityChanges}
                    >Save</span>
                    }
                </h2> 
               <div
                    style={{paddingLeft: 10, paddingTop: 10}}
               >
                 <Checkbox 
                    className="settings-checkbox"
                    label="Enable Multi-Factor Authentication"
                    checked={this.state.mfaEnabled}
                    onToggle={this.handleMfaToggle}
                />
                <Checkbox 
                    className="settings-checkbox"
                    label="Manage user accounts with Azure Active Directory"
                    checked={this.state.ssoEnabled}
                    onToggle={this.handleSsoToggle}
                    disabled={this.props.users.some(user => user.membershipCount > 1 && !user.email.endsWith('@stax.ai'))}
                />

                {this.state.ssoEnabled &&
                <>
                    <div style={{display: 'flex', flexDirection: 'column'}}>
                        <h2>Provider Entity ID</h2>
                        <input 
                            style={{margin: 0, marginLeft: 20}}
                            value={this.state.samlIssuer}
                            onChange={(e) => {
                                this.setState({samlIssuer: e.target.value, securityChanged: true})
                            }}
                            type='text'
                        />
                         <span style={{
                            paddingLeft: 22, 
                            color: 'var(--color-text-light)'
                        }}>The URL your identity provider uses for SAML 2.0</span>
                    </div>

                    <div style={{display: 'flex', flexDirection: 'column'}}>
                        <h2>Public x509 certificate</h2>
                        <textarea
                            className="settings-textarea"
                            style={{
                                width: 360,
                                height: 144,
                                marginLeft: 20,
                                padding: 15
                            }}
                            placeholder={
                                "-----BEGIN CERTIFICATE-----\n" +
                                "....\n" + 
                                "-----END CERTIFICATE-----\n"
                            }
                            value={this.state.samlCert}
                            onChange={(e) => {
                                this.setState({samlCert: e.target.value, securityChanged: true})
                            }}
                        />
                         <span style={{
                            paddingLeft: 22, 
                            color: 'var(--color-text-light)'
                        }}>Copy and paste the entire certificate</span>
                    </div>
                    
                    <div>
                        <h2>Provider entity URL</h2>
                        <div
                            key={0}
                            className="settings-user-apikey"
                        >
                            <label>Click to copy →</label>
                            <input
                                id={"copykey-"}
                                name="copykey"
                                type="text"
                                style={{ cursor: 'pointer' }}
                                title="Click to copy key"
                                placeholder="Loading..."
                                value={api.apiUrl + `/user/login/sso/${this.props.team._id}`}
                                onClick={(e) => {
                                    toast.info("Copied to clipboard");
                                    copyText(e.target.value);
                                }}
                                readOnly
                            />
                        </div>
                    </div>
                    
                    <div>
                        <h2>Provider assertion consumer service URL</h2>
                        <div
                            key={0}
                            className="settings-user-apikey"
                        >
                            <label>Click to copy →</label>
                            <input
                                id={"copykey-"}
                                name="copykey"
                                type="text"
                                style={{ cursor: 'pointer' }}
                                title="Click to copy key"
                                placeholder="Loading..."
                                value={ api.apiUrl + `/user/login/sso/callback/${this.props.team._id}`}
                                onClick={(e) => {
                                    copyText(e.target.value);
                                    toast.info("Copied to clipboard");
                                }}
                                readOnly
                            />
                        </div>
                    </div>
                </>}
               </div>
            </div>
            </>
        )

    } 

}